import { makeStyles } from '@material-ui/styles'

export default makeStyles(({ spacing }) => ({
  main: {
    display: 'flex',
    flexDirection: 'column',
    padding: '30px 0px 10px 0px',
  },
  container: {
    display: 'flex',
    width: '100%',
    height: '100%',
    padding: '0px 32px 32px',
    flexDirection: 'column',
  },
  checkbox: {
    marginRight: spacing(5),
  },
  subcontainer: {
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '38px 22px 12px',
    marginBottom: '30px',
    flexDirection: 'column',
    border: '1px solid #E3E3E3',
    borderRadius: '8px',
    gap: '24px',
  },
  wrapper: {
    display: 'grid',
    gridTemplateColumns: '320px 320px 320px',
    alignItems: 'start',
    marginRight: 'auto',
    width: '100%',
    gap: '44px',
    position: 'relative',
  },
  wrapperFull: {
    width: '100%',
    position: 'relative',
  },
  label: {
    top: '-8px',
    left: '14px',
    padding: '0px 6px',
    position: 'absolute',
    backgroundColor: 'white',
  },
  inputLabel: {
    color: 'black !important',
    fontSize: '12px !important',
    fontWeight: '500 !important',
    display: 'flex',
    gap: '4px',
  },
  cpfCnpjField: {
    marginTop: '-6px',
  },
  checkboxField: {
    marginTop: '-40px',
    marginLeft: '5px',
  },
}))
